/// <reference path="index.d.ts" />
import 'core-js/stable';
import { initCapacitorEarly } from 'modules/app/capacitor';
import { initializeIntercom } from 'services/IntercomService';
import 'styles/global.scss';
import 'utils/CustomEventPolyfill';
import { isCordova } from 'utils/platform';
import useAuthStore from '~/authentication/store';
import { useDeviceInfoStore } from '~/stores/device';
import { useRecentSearchesStore } from '~/stores/recentSearches';

import Main from './Main';
import UI from './ui';

async function initCordova() {
  await useAuthStore.persist.rehydrate();
  await initCapacitorEarly();
  await useDeviceInfoStore.getState().init();
}

function loadMain() {
  Main();
  useRecentSearchesStore.getState().init();
  UI();
  if (isCordova()) {
    initCordova();
  } else {
    initializeIntercom();
  }
}

if (isCordova()) {
  document.addEventListener('deviceready', loadMain, false);
} else {
  loadMain();
}
